(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sissi-swatch-visual"] && !Shopify.designMode) return;
  try {
    if (!window.sissiSwatchSelectionBound) {
    window.sissiSwatchSelectionBound = true;
    document.addEventListener('change', (event) => {
      if (!event.target.matches('.product-form__input--sissi-swatches input[type="radio"]')) return;
      const fieldset = event.target.closest('.product-form__input--sissi-swatches');
      const selectedLabel = fieldset?.querySelector('.sissi-swatch__selected');
      if (selectedLabel) selectedLabel.textContent = `: ${event.target.value}`;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
